<template>
    <SelectGroup :class="[element('group'), $attrs.class]">
        <SelectLabel
            v-if="label"
            :class="element('group-label')"
        >
            {{ label }}
        </SelectLabel>

        <slot />
    </SelectGroup>
</template>

<script setup lang="ts">
import type { KSelectGroupProps } from './types'
import useBem from '@yeeroen/use-bem'
import { SelectGroup, SelectLabel } from 'reka-ui'

defineOptions({ name: 'KSelectGroup', inheritAttrs: false })

defineProps<KSelectGroupProps>()

defineSlots<{ default?: () => unknown }>()

// See KSelectItem: the popup is its own BEM block and owns these elements' classes.
// The stylesheet is emitted once by KSelect — the only component these render inside.
const { element } = useBem('k-select-content')
</script>
